import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { EditCommentRequest } from '@/api/generated/HCA'
import { ComponentType } from '@/configuration/component/component-types'

export const useCommentsEditMutation = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (payload: { commentData: EditCommentRequest, componentSid: string, componentType: ComponentType, analysisType?: number }) =>
            hcaClientFactory.commentsApi.editComment(payload.commentData),
        onSuccess: async (response, payload) => {
            if (payload.analysisType !== undefined && payload.analysisType !== null) {
                if (payload.componentType === ComponentType.Transformer) {
                    await queryClient.invalidateQueries({ queryKey: ['transformers', payload.componentSid, 'reports', payload.analysisType] })
                } else if (payload.componentType === ComponentType.Generator) {
                    await queryClient.invalidateQueries({ queryKey: ['generators', payload.componentSid, 'measurements', payload.analysisType] })
                }
            }
            await queryClient.invalidateQueries({ queryKey: ['comments', payload.componentSid] })
        },
    })
}
